export default "__VITE_ASSET__Bs4bcUls__"